import { motion } from "framer-motion";
import { MapPin, Circle } from "@phosphor-icons/react";
import { t } from "../i18n";
import { fadeUp, stagger, viewport } from "../motion";

export default function ServiceArea() {
  const a = t.de.area;
  return (
    <section id="area" data-testid="service-area" className="py-24 md:py-36 bg-white">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewport}>
            <motion.div variants={fadeUp} className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-gold-500" />
              <span className="text-xs font-semibold uppercase tracking-[0.25em] text-gold-600">{a.overline}</span>
            </motion.div>
            <motion.h2 variants={fadeUp} className="text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-navy-900 leading-tight">
              {a.title}
            </motion.h2>
            <motion.p variants={fadeUp} className="mt-6 text-lg text-slate-600 leading-relaxed max-w-md">{a.lead}</motion.p>
            <motion.div variants={fadeUp} className="mt-8 flex flex-wrap gap-3">
              {a.cities.map((city) => (
                <span key={city} className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-gold-50 border border-gold-100 text-navy-900 font-medium">
                  <MapPin size={16} weight="fill" className="text-gold-500" />
                  {city}
                </span>
              ))}
            </motion.div>
            <motion.p variants={fadeUp} className="mt-6 text-sm text-slate-500 max-w-md">{a.note}</motion.p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={viewport}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="relative aspect-square max-w-lg mx-auto w-full"
          >
            <div className="absolute inset-0 rounded-full bg-gradient-to-br from-navy-900 to-navy-950 grain overflow-hidden" />
            {/* concentric radius rings */}
            {[0.35, 0.6, 0.85].map((s, i) => (
              <div key={i} className="absolute rounded-full border border-gold-500/25" style={{ inset: `${(1 - s) * 50}%` }}>
                <motion.div
                  animate={{ opacity: [0.2, 0.5, 0.2] }}
                  transition={{ repeat: Infinity, duration: 3, delay: i * 0.5 }}
                  className="absolute inset-0 rounded-full border border-gold-500/20"
                />
              </div>
            ))}
            {/* center = Ebrach */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center">
              <div className="w-4 h-4 rounded-full bg-gold-500 ring-4 ring-gold-500/30" />
              <span className="mt-2 text-white text-xs font-medium tracking-wide">Ebrach</span>
              <span className="text-gold-400 text-[10px]">~50 km Umkreis</span>
            </div>
            {/* city pins */}
            {[
              { name: "Würzburg", top: "24%", left: "30%" },
              { name: "Kitzingen", top: "38%", left: "68%" },
              { name: "Bamberg", top: "70%", left: "62%" },
            ].map((c) => (
              <div key={c.name} className="absolute flex flex-col items-center -translate-x-1/2 -translate-y-1/2" style={{ top: c.top, left: c.left }}>
                <Circle size={12} weight="fill" className="text-white" />
                <span className="mt-1 text-white/80 text-[11px] font-medium whitespace-nowrap">{c.name}</span>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
